import { initTechnologiesCarousel } from '@components/sliders/sliders'

document.addEventListener('DOMContentLoaded', () => {
  initTechnologiesCarousel()
}, { once: true })
